document.addEventListener("DOMContentLoaded", (event) => {

    const swiper_realization = document.querySelector('.__swiper_realization');
    if( swiper_realization ){
        const swiper = new Swiper('.__swiper_realization', {
            slidesPerView: 1,
            spaceBetween: 10,
            navigation: {
                nextEl: '.__swiper-button-next',
                prevEl: '.__swiper-button-prev',
            },
            breakpoints: {
                // when window width is >= 1200px
                1200: {
                    spaceBetween: 32,
                    slidesPerView: 3,
                },
                // when window width is >= 1024px
                1024: {
                    spaceBetween: 15,
                    slidesPerView: 3,
                },
                // when window width is >= 768px
                768: {
                    spaceBetween: 15,
                    slidesPerView: 2,
                },
            }
        });
    }

    const horizontalScroll = document.querySelector('.__horizontalScroll');
    if( swiper_realization ) {
        initScroll();
    }
    //To learn more about using GreenSock's bonus plugins for free on CodePen visit: https://gsap.com/trial
    function initScroll() {
        const container = document.querySelector(".__horizontalScroll");
        const sections = gsap.utils.toArray(".__section");
        const screenWidth = window.innerWidth;
        if (screenWidth < 768) {
            const mobile_title = document.querySelector('.__mobile_title');
            const height_mobile_title = mobile_title.offsetHeight;
            container.style.marginTop = height_mobile_title + 'px';
            mobile_title.style.top = '-' + height_mobile_title + 'px';

        }
        // if (screenWidth > 992) {
            function getScrollAmount() {
                let containerWidth = container.scrollWidth + 20;
                if (screenWidth > 992) {
                    containerWidth = container.scrollWidth + 50;
                }
                return -(containerWidth - screenWidth);
            }

            const scrollTween = gsap.to(sections, {
                x: getScrollAmount,
                duration: 3,
                ease: "none",
            });

            ScrollTrigger.create({
                trigger: ".__horizontalScroll",
                end: () => `+=${getScrollAmount() * -1}`,
                pin: true,
                animation: scrollTween,
                scrub: 1,
                invalidateOnRefresh: true,
                // markers: true
            });


        // }
    }

});
